import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import React, { useState, useEffect } from 'react';

import { Cart, PersonCircle, Search } from 'react-bootstrap-icons';
import CartIcon from '../UIComponents/CartButton';
import UserIcon from '../blocks/UIIconUser';
import ContactUsIcon from '../UIComponents/UIIconContactUs';


import SideScreenOverlay from '../sections/SideScreenOverlay';
import ContactForm from '../forms/ContactUs';

import CartPage from '../pageoverlays/Cart';
import SearchPage from '../pageoverlays/Search';

import UserAccount from '../pageoverlays/UserInfo';
import { INTRFAddress, INTRFUser } from '../../hooks/Interfaces';
/* lifting state up */
interface AccountInfoProps {
    /*itemid: string;*/
    user: INTRFUser;
    carteditems: number;
    updatefunc: () => void;
    updatecsrf: (value: string) => void;
    updatesession: (value: string) => void;
}


function CardAccountInfo({user, carteditems, updatefunc, updatecsrf, updatesession}: AccountInfoProps){
    const [contactViewable, setContactViewable] = useState(false);
    const [cartViewable, setCartViewable] = useState(false);
    const [userViewable, setUserViewable] = useState(false);
    const [searchViewable, setSearchViewable] = useState(false);

    function ContactViewable(){
        setContactViewable(true)
    }

    function CartViewable(){
        setCartViewable(true)
    }

    function UserSectionViewable(){
        setUserViewable(true)
    }

    function SearchViewable(){ setSearchViewable(true) }

    return (
        <> 
            <Container className=''>
                <Row className="align-items-end">
                    <Col xs={{ span: 3 }} onClick={SearchViewable}>
                        <Search size={26} />
                        <p className="smallest-copy-style text-font-body my-0">Search</p>
                    </Col>
                    <Col xs={{ span: 3 }} className="align-self-end">
                        <UserIcon clickfunc={UserSectionViewable} name={user.username} />
                    </Col>
                    <Col xs={{ span: 3 }}>
                        <CartIcon clickfunc={CartViewable} items={carteditems} />
                        <p className="smallest-copy-style text-font-body my-0">Cart</p>
                    </Col>
                    <Col xs={{ span: 3 }}>
                        <ContactUsIcon clickfunc={ContactViewable} />
                        <p className="smallest-copy-style text-font-body my-0">Contact</p>
                    </Col>
                </Row>
            </Container>

            {cartViewable && <SideScreenOverlay closefunc={setCartViewable}><CartPage user={user} updatefunc={updatefunc}/></SideScreenOverlay> }
            {contactViewable && <SideScreenOverlay closefunc={setContactViewable}><ContactForm /></SideScreenOverlay> }
            {searchViewable && <SideScreenOverlay closefunc={setSearchViewable}><SearchPage user={user} updatefunc={updatefunc}/></SideScreenOverlay> }
            {userViewable && <SideScreenOverlay closefunc={setUserViewable}><UserAccount user={user} updatecsrf={updatecsrf} updatesession={updatesession} /></SideScreenOverlay> }

        </>
    )
}

export default CardAccountInfo;